import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";
import {s_char_matrices} from "../_signals/s_char";
import {ICharMatrice} from "../_interfaces/ICharMatrice";

export const MatricesGet = (cid: string) => {
    fetch(apiAddress + "/char/matrices/" + cid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => {
                console.log('BEMatrices get reponse', data);
                if (data.hasOwnProperty('result')) {
                    s_char_matrices.value = (data.result as ICharMatrice[])
                }
            }
        )
        .catch((reason => {
            console.log('BEMatrices get catch', reason);
        }))
}

export const MatricesCreate = (matrice: ICharMatrice) => {
    fetch(apiAddress + "/char/matrices/", createOptions('CREATE', matrice))
        .then((res) => res.json())
        .then((data) => console.log('BEMatrices create reponse', data))
        .catch((reason => console.log('BEMatrices create catch', reason)))
}

export const MatricesUpdate = (matrice: ICharMatrice) => {
    fetch(apiAddress + "/char/matrices/", createOptions('UPDATE', matrice))
        .then((res) => res.json())
        .then((data) => console.log('BEMatrices update response', data))
        .catch((reason => console.log('BEMatrices update catch', reason)))
}

export const MatricesDelete=(matrice: ICharMatrice)=> {
    fetch(apiAddress + "/char/matrices/", createOptions('DELETE', matrice))
        .then((res) => res.json())
        .then((data) => console.log('BEMatrices delete response', data))
        .catch((reason => console.log('BEMatrices delete catch', reason)))
}